import { routerMiddleware } from 'connected-react-router';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import { callAPI } from './common/middleware';

export default history => {
    const router = routerMiddleware(history);
    const logger = createLogger();

    return [thunk, callAPI, router, logger]
};